import React, {FC, ReactNode} from 'react';

interface PanelProps {
  readonly children: ReactNode;
}
const Panel: FC<PanelProps> = ({children}) => <>{children}</>;

export {Panel};
